import { render } from "./CometChatReceiverTextMessageBubble.vue?vue&type=template&id=d223ddaa"
import script from "./CometChatReceiverTextMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatReceiverTextMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatReceiverTextMessageBubble.vue?vue&type=style&index=0&id=d223ddaa&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__